import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { MyFitmentsRoutingModule } from './my-fitments-routing.module';
// import { ContextualActionModule } from './components/contextual-actions/contextual-action.module';

import { MyFitmentsSearchService } from 'shared/fitments/search/my-fitments-search.service';
import { SearchPageService } from 'shared/search-page/search-page.service';
import { ProductsSearchService } from './components/products-search/products-search.service';

import { MyFitmentsComponent } from './my-fitments.component';
import { ProductsSearchComponent } from './components/products-search/products-search.component';
import { AssignToProductsModalComponent } from './components/assign-to-products-modal/assign-to-products-modal.component';
import { ProductListsSearchComponent } from './components/product-lists-search/product-lists-search.component';
import { LoadProductModalComponent } from './components/load-product-modal/load-product-modal.component';
import { MyFitmentsHeaderComponent } from './components/my-fitments-header/my-fitments-header.component';
import { MyFitmentsSearchComponent } from './components/my-fitments-search/my-fitments-search.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    SharedModule,
    MyFitmentsRoutingModule,
  ],
  declarations: [
    MyFitmentsComponent,
    ProductsSearchComponent,
    AssignToProductsModalComponent,
    ProductListsSearchComponent,
    LoadProductModalComponent,
    MyFitmentsHeaderComponent,
    MyFitmentsSearchComponent,
  ],
  exports: [MyFitmentsComponent],
  providers: [
    MyFitmentsSearchService,
    SearchPageService,
    ProductsSearchService,
  ]
})
export class MyFitmentsModule {}
